import React from 'react'
import { GoArrowLeft, GoArrowRight } from "react-icons/go";


const Pagination = ({setLoading, totalPages, setCurrentPage, currentPage, chunkSize, chunkStart}) => {
    const handlePrev = () => {
      setLoading(true)
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1)
      }
    };
    
    const handleNext = () => {
      setLoading(true)
      if (currentPage !== totalPages) {
        setCurrentPage(currentPage + 1)
      }else{
        return null
      }
    };

    const handlePageChange = (pageNumber) => {
      setLoading(true)
      setCurrentPage(pageNumber);
    };
  
    // const handleNextChunk = () => {
    //   setChunkIndex(chunkIndex + 1);
    // };
  
    // const handlePrevChunk = () => {
    //   setChunkIndex(chunkIndex - 1);
    // };


  return (
    <div className='flex items-center justify-between w-full border-[1px] border-[#DDE1E6] rounded-md py-2 px-3 md:py-2.5 md:px-4 lg:py-3 lg:px-5 xl:px-6'>
            <div onClick={() => handlePrev()}
            className='flex items-center py-1 px-2 border-[1px] border-[#DDE1E6] rounded cursor-pointer text-[#25A249] hover:bg-[#25A249] hover:text-white xl:py-1.5 
                            xl:px-2.5 xl:rounded-md'>
                <GoArrowLeft className='text-[11px] md:text-[12px] xl:text-base' />
                <p className='text-[9px] pl-1 hover:text-[#FFFFFF] md:text-[10px] lg:pl-1.5 xl:text-[12px]'>
                    Previous
                </p>
            </div>

            <div className='flex items-center justify-center'>
                {/* {pagination.map((item) => {
                  return(
                    <div key={item} onClick={()=>handleTable(item)}
                    className={`flex items-center justify-center h-5 w-5 rounded cursor-pointer md:mx-[2px] xl:mx-1 xl:h-6 xl:w-6 ${table === item && 'bg-[#DCF0E2]'}`}>
                        <p className={`text-[9px] md:text-[10px] xl:text-[12px] ${table === item ? 'text-[#25A249]' : 'text-[#53545C]'}`}>
                           {item}
                        </p>
                    </div>
                  )
                })} */}
                {/* {Array(totalPages)
                 .fill(0)
                 .map((_, index) => (
                   <div key={index} onClick={() => handlePageChange(index + 1)}
                   className={`flex items-center justify-center h-5 w-5 rounded cursor-pointer md:mx-[2px] xl:mx-1 xl:h-6 xl:w-6 ${currentPage === index && 'bg-[#DCF0E2]'}`}>
                       <p className={`text-[9px] md:text-[10px] xl:text-[12px] ${currentPage === index ? 'text-[#25A249]' : 'text-[#53545C]'}`}>
                           {index + 1}
                       </p>
                   </div>
                 ))} */}

                 {Array(chunkSize).fill(0).map((_, index) => (
                    <div key={index} onClick={() => handlePageChange(chunkStart + index + 1)}
                    className={`flex items-center justify-center h-5 w-5 rounded cursor-pointer md:mx-[2px] xl:mx-1 xl:h-6 xl:w-6 ${currentPage === chunkStart + index + 1 && 'bg-[#DCF0E2]'}`}>
                        <p className={`text-[9px] md:text-[10px] xl:text-[12px] ${currentPage === chunkStart + index + 1 ? 'text-[#25A249]' : 'text-[#53545C]'}`}>
                            {chunkStart + index + 1}
                        </p>
                    </div>
                  ))}
            </div>

            <div onClick={() => handleNext()}
            className='flex items-center py-1 px-2 border-[1px] border-[#DDE1E6] rounded cursor-pointer text-[#25A249] hover:bg-[#25A249] hover:text-white xl:py-1.5
                            xl:px-2.5 xl:rounded-md'>
                <p className='text-[9px] pr-1 md:text-[10px] lg:pr-1.5 xl:text-[12px]'>
                    Next
                </p>
                <GoArrowRight className='text-[11px] md:text-[12px] xl:text-base' />
            </div>
        </div>
  )
}

export default Pagination
